import React, { useMemo, useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCustomer } from "../../../../stores/customersStore";
import PromiseWait from "../../../shared/PromiseWait";
import CustomerPageContent from "./CustomerPageContent";


const CustomerPage: React.FC = () => {
  const { customerId } = useParams<{ customerId: string }>();
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [notes, setNotes] = useState<string[]>([]);
  
  const promise = useMemo(() => {
    // Explicitly reference refreshCounter to trigger re-fetch when it changes
    void refreshCounter;
    return getCustomer(customerId);
  }, [customerId, refreshCounter]);

  const handleRefresh = useCallback(() => {
    setRefreshCounter(prev => prev + 1);
  }, []);

  const handleNotesUpdate = useCallback((newNotes: string[]) => {
    setNotes(newNotes);
  }, []);

  // Clear notes when doing a full refresh
  useEffect(() => {
    setNotes([]);
  }, [refreshCounter]);

  return (
    <PromiseWait 
      promise={promise} 
      component={CustomerPageContent} 
      mapComponentProps={(customer) => ({
        ...customer,
        notes: notes.length > 0 ? notes : customer.notes, // Use updated notes if available
        onRefresh: handleRefresh,
        onNotesUpdate: handleNotesUpdate
      })} 
    />
  );
};

export default CustomerPage;
